import dtwinService from "../services/dtwin.service";
import type { GenericParameters } from "~/core/models/GenericParameters.type";
import LxcError from "~/core/models/LxcError.class";

export function useUpdateDtwin({ organizationCode }: GenericParameters) {
  const isLoading = ref(false);
  const error = ref<LxcError | null>(null);

  async function updateDtwin(
    uid: string,
    data: Record<string, unknown>,
  ): Promise<void> {
    isLoading.value = true;
    error.value = null;

    const response = await dtwinService.patchOrganizationDtwin({
      organizationCode,
      uid,
      data,
    });

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    updateDtwin,
    error,
    isLoading,
  };
}
